export interface ConnectivityStateInput {
  online:boolean; failed:boolean; saving:boolean; attention:number; blocked:boolean; pending:number
  syncing:boolean; preparing:boolean; active:boolean; ready:boolean
}
export function connectivityState(s:ConnectivityStateInput) {
  if(s.failed) return {key:'failed',icon:'mdi-alert-circle',color:'error'}
  if(s.saving) return {key:'saving',icon:'mdi-loading',color:'info'}
  if(s.attention || s.blocked) return {key:'attention',icon:'mdi-alert',color:'warning'}
  if(!s.online && s.active && !s.ready) return {key:'unavailable',icon:'mdi-wifi-off',color:'error'}
  if(s.online && s.syncing && s.pending) return {key:'syncing',icon:'mdi-sync',color:'success'}
  if(s.pending) return {key:'pending',icon:s.online?'mdi-cloud-upload-outline':'mdi-wifi-off',color:s.online?'success':'warning'}
  if(!s.online) return {key:s.ready?'offlineReady':'offline',icon:'mdi-wifi-off',color:'warning'}
  if(s.preparing) return {key:'preparing',icon:'mdi-cloud-download-outline',color:'info'}
  return {key:s.ready?'ready':s.active?'unprepared':'online',icon:'mdi-wifi',color:s.ready?'success':'inherit'}
}
